import { render } from "./ConfirmSize.vue?vue&type=template&id=bc504300&scoped=true"
import script from "./ConfirmSize.vue?vue&type=script&lang=js"
export * from "./ConfirmSize.vue?vue&type=script&lang=js"

import "./ConfirmSize.vue?vue&type=style&index=0&id=bc504300&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc504300"]])

export default __exports__